import { AuthenticationType } from 'authentication/shared/types'
import { useSelector } from 'react-redux'
import { useFetchYesObjects } from 'yesObject/shared'

const useHomeSitemodels = () => {
  const token = useSelector(
    ({ authentication }: AuthenticationType) => authentication.token
  )

  const {
    yesObjects: homeSitemodels,
    isLoading,
    fetchYesObjects: fetchHomeSitemodels,
    isFetched
  } = useFetchYesObjects({
    filteractionUuid: window.defaultSitemodelFilteractionUuid,
    showLoading: true,
    initialSortOptions: [{ priority: 'desc' }],
    additionalQueryKeyParams: [token ?? '']
  })

  return {
    homeSitemodels,
    fetchHomeSitemodels,
    isLoading,
    isFetched
  }
}

export default useHomeSitemodels
